import {
  ACTION_CREATE,
  ACTION_DELETE,
  ACTION_FORCE,
  ACTION_GET,
  ACTION_LIST,
  ACTION_UPDATE,
  ACTION_OPEN,
} from './base';

export const PREFIX_VAULT_SECRETS = 'secrets';

export const SECRETS_APP = 'apps';
export const SECRETS_APP_SECRETS = 'app-secrets';
export const SECRETS_APP_SECRET_VERSIONS = 'app-secret-versions';
export const SECRETS_SYNC_INSTALLATIONS = 'sync-installations';
export const SECRETS_SYNC_INTEGRATIONS = 'sync-integrations';
export const SECRETS_USAGE = 'usage';

export const replaceWithDeprecatedPrefix = (permissionStr) => permissionStr;

export const SECRETS_ALL_PERMISSIONS = [
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_CREATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_DELETE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_UPDATE}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_CREATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_DELETE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_OPEN}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_UPDATE}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRET_VERSIONS}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRET_VERSIONS}.${ACTION_OPEN}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INSTALLATIONS}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INSTALLATIONS}.${ACTION_CREATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INSTALLATIONS}.${ACTION_DELETE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INSTALLATIONS}.${ACTION_UPDATE}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_CREATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_DELETE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_UPDATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_FORCE}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_USAGE}.${ACTION_GET}`,
];

export const SECRETS_OWNER_ROLE_PERMISSIONS = [...SECRETS_ALL_PERMISSIONS];

export const SECRETS_ADMIN_ROLE_PERMISSIONS = [...SECRETS_ALL_PERMISSIONS];

export const SECRETS_CONTRIBUTOR_ROLE_PERMISSIONS = [
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_CREATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_DELETE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_UPDATE}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_CREATE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_DELETE}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_OPEN}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_UPDATE}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRET_VERSIONS}.${ACTION_LIST}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INSTALLATIONS}.${ACTION_GET}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_SYNC_INTEGRATIONS}.${ACTION_LIST}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_USAGE}.${ACTION_GET}`,
];
export const SECRETS_VIEWER_ROLE_PERMISSIONS = [
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}.${ACTION_LIST}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_GET}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_LIST}`,
  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRETS}.${ACTION_OPEN}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_APP_SECRET_VERSIONS}.${ACTION_LIST}`,

  `${PREFIX_VAULT_SECRETS}.${SECRETS_USAGE}.${ACTION_GET}`,
];
